<template>
    <component :is="layout">
        <router-view/>
    </component>
</template>

<script>
    import MainTemplate from './Layouts/MainTemplate'
    import LoginTemplate from './Layouts/LoginTemplate'
    import ChangeCardTemplate from './Layouts/ChangeCardTemplate'
    import FullPage from './Layouts/FullPage'

    export default {
        data() {
            return {
                layout: 'login-template'
            }
        },
        components: {
            MainTemplate,
            LoginTemplate,
            ChangeCardTemplate,
            FullPage
        },
        watch:{
            $route (to, from){
                // window.Appcues.page();
                this.layout = this.$route.meta.layout
            }
        },
        mounted(){
            this.layout = this.$route.meta.layout
        },
        methods:{
            
        }
    }
</script>